// extracted by mini-css-extract-plugin
export default {"investmentdocs":"InvestmentDocument_investmentdocs__iTQrT","title":"InvestmentDocument_title__ajlN7"};